<template>
  <div class="uploader-item">
    <div class="progress" v-show="isUploading || isFail || isWait">
      <el-progress
        type="circle"
        :percentage="progress"
        :width="50"
        :stroke-width="3"
        :status="isFail ? 'exception' : null"
      ></el-progress>
    </div>
    <i class="el-icon-download top" v-show="index > 0" @click="handleTop"></i>
    <i
      class="el-icon-close delete"
      v-show="isSuccess || isFail"
      @click="handleDelete"
    ></i>
    <video :src="videos.src" autoplay muted loop v-if="type == 'video'" @click="handleClick(videos.url)"></video>
    <img :src="images.src" v-else @click="handleClick(images.url)" />
  </div>
</template>

<script>
export default {
  name: "UploaderItem",
  props: {
    index: Number,
    images: Object,
    videos: Object,
    type: String
  },
  computed: {
    canDelete: function() {
      return true;
    },
    isUploading: function() {
      if (this.type == "video") {
        return this.videos.state === "uploading";
      } else {
        return this.images.state === "uploading";
      }
    },
    progress: function() {
      if (this.type == "video") {
        return parseInt(this.videos.progress * 100);
      } else {
        return parseInt(this.images.progress * 100);
      }
    },
    isFail: function() {
      if (this.type == "video") {
        return this.videos.state === "fail";
      } else {
        return this.images.state === "fail";
      }
    },
    isSuccess: function() {
      if (this.type == "video") {
        return this.videos.state === "success";
      } else {
        return this.images.state === "success";
      }
    },
    isWait: function() {
      if (this.type == "video") {
        return this.videos.state === "wait";
      } else {
        return this.images.state === "wait";
      }
    }
  },
  methods: {
    handleDelete() {
      this.$emit("delete");
    },
    handleTop(){
      this.$emit("top");
    },
    handleClick(url){
      this.$emit("view",url);
    }
  }
};
</script>

<style lang="scss" scoped>
.uploader-item {
  position: relative;

  & > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  & > video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  & > .progress {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;

    ::v-deep {
      &.is-exception .el-progress__text {
        color: #f56c6c;
      }
      .el-progress__text {
        color: white;
      }
    }
  }

  & > .delete {
    position: absolute;
    width: 20px;
    height: 20px;
    background-color: #a0a0a0;
    color: white;
    line-height: 20px;
    text-align: center;
    border-radius: 50%;
    top: 8px;
    right: 8px;
    z-index: 10;
    cursor: pointer;
  }

  & > .top {
    position: absolute;
    width: 20px;
    height: 20px;
    background-color: #a0a0a0;
    color: white;
    line-height: 20px;
    text-align: center;
    border-radius: 50%;
    top: 8px;
    right: 32px;
    z-index: 10;
    cursor: pointer;
    transform: rotateX(180deg);
  }
}
</style>
